import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Avatar, Form, Button, Input, List, message, Spin, Divider, Tag } from 'antd';
import { Comment } from '@ant-design/compatible';
import { UserOutlined, LikeOutlined, DislikeOutlined, EyeOutlined, MessageOutlined } from '@ant-design/icons';
import axios from 'axios';

const { TextArea } = Input;

const TopicDiscussion = () => {
    const { topicId } = useParams();
    const navigate = useNavigate();
    const [topic, setTopic] = useState(null);
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        const fetchTopicDetails = async () => {
            try {
                setLoading(true);
                const [topicResponse, commentsResponse] = await Promise.all([
                    axios.get(`/forum/topics/${topicId}`),
                    axios.get(`/forum/comments/${topicId}`)
                ]);
                setTopic(topicResponse.data);
                setComments(commentsResponse.data);

                // Ko'rishlar sonini oshirish
                // await axios.post(`/forum/topics/${topicId}/view`);
            } catch (error) {
                console.error('Ma\'lumotlarni yuklashda xatolik:', error);
                message.error('Ma\'lumotlarni yuklashda xatolik yuz berdi');
                if (error.response?.status === 404) {
                    navigate('/forum');
                }
            } finally {
                setLoading(false);
            }
        };
        fetchTopicDetails();
    }, [topicId, navigate]);


    const handleComment = async (values) => {
        try {
            setSubmitting(true);
            const response = await axios.post('/forum/comments', {
                topic_id: topicId,
                user_id: localStorage.getItem('token'),
                content: values.comment
            });
            setComments([...comments, response.data]);
            form.resetFields();
            message.success('Kommentariya qo\'shildi');
        } catch (error) {
            console.error('Kommentariya qo\'shishda xatolik:', error);
            message.error('Kommentariya qo\'shishda xatolik yuz berdi');
        } finally {
            setSubmitting(false);
        }
    };

    if (loading) {
        return (
            <div style={{ textAlign: 'center', padding: '50px' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!topic) {
        return (
            <div style={{ textAlign: 'center', padding: '50px' }}>
                <h2>Mavzu topilmadi</h2>
                <Button type="primary" onClick={() => navigate('/forum')}>
                    Forumga qaytish
                </Button>
            </div>
        );
    }

    return (
        <div className="topic-discussion" style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
            {/* Mavzu ma'lumotlari */}
            <Card className="topic-card">
                <div style={{ marginBottom: '16px' }}>
                    <Tag color="blue">{topic[0]?.category_id || 'Umumiy'}</Tag>
                </div>
                <h1 style={{ fontSize: '28px', marginBottom: '16px' }}>{topic[0]?.title}</h1>
                <p style={{ fontSize: '16px', whiteSpace: 'pre-wrap', marginBottom: '24px' }}>
                    {topic[0]?.description}
                </p>
                <Divider />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#8c8c8c' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar
                            icon={<UserOutlined />}
                            src={topic[0]?.user?.avatar}
                            style={{ marginRight: '8px' }}
                        />
                        <span>{topic[0]?.fullname || 'Noma\'lum'}</span>
                    </div>
                    <div>
                        <span style={{ marginRight: '16px' }}>
                            <EyeOutlined /> {topic.views}
                        </span>
                        <span style={{ marginRight: '16px' }}>
                            <MessageOutlined /> {comments.length}
                        </span>
                        <span>{new Date(topic[0]?.created_at).toLocaleString('uz-UZ')}</span>
                    </div>
                </div>
            </Card>

            {/* Kommentariyalar */}
            <div style={{ marginTop: '24px' }}>
                <h2 style={{ fontSize: '20px', marginBottom: '16px' }}>
                    Kommentariyalar ({comments.length})
                </h2>
                <List
                    className="comment-list"
                    itemLayout="horizontal"
                    dataSource={comments}
                    locale={{ emptyText: 'Hozircha kommentariyalar yo\'q' }}
                    renderItem={comment => (
                        <List.Item>
                            <Comment
                                style={{ padding: '15px', width: '100%' }}
                                author={<a>{comment?.user?.fullname || 'Noma\'lum'}</a>}
                                avatar={
                                    <Avatar
                                        icon={<UserOutlined />}
                                        src={comment?.user?.avatar}
                                    />
                                }
                                content={
                                    <div>
                                        <p style={{ whiteSpace: 'pre-wrap' }}>{comment?.content}</p>
                                    </div>
                                }
                                datetime={new Date(comment?.created_at).toLocaleString('uz-UZ')}
                                actions={[
                                    <span key="like">
                                        <LikeOutlined /> Like
                                    </span>,
                                    <span key="dislike">
                                        <DislikeOutlined /> Dislike
                                    </span>
                                ]}
                            />
                        </List.Item>
                    )}
                />
            </div>

            {/* Kommentariya yozish */}
            <div style={{ marginTop: '24px' }}>
                <Form form={form} onFinish={handleComment}>
                    <Form.Item
                        name="comment"
                        rules={[{ required: true, message: 'Iltimos, kommentariya matnini kiriting' }]}
                    >
                        <TextArea
                            rows={4}
                            placeholder="Kommentariyangizni yozing..."
                            maxLength={1000}
                            showCount
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={submitting}
                            disabled={submitting}
                        >
                            Kommentariya qoldirish
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default TopicDiscussion;
